export var SupportedChains;
(function (SupportedChains) {
    SupportedChains["Injective"] = "injective";
    SupportedChains["Cosmos"] = "cosmos";
    SupportedChains["Ethereum"] = "ethereum";
    SupportedChains["Solana"] = "solana";
})(SupportedChains || (SupportedChains = {}));
//# sourceMappingURL=explorer.js.map